import {
  Stack
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Glasses, Timer } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  InfoTypography,
  TopicCardSignatureStack
} from "./TopicCardSignature.styles";
import type { TopicCardSignatureProps } from "./TopicCardSignature.types";

export function TopicCardSignature({
  color,
  created,
  isModified,
  readingTime,
  size,
  ...props
}: TopicCardSignatureProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  const fontSize = size === "medium" ? "1rem" : "0.875rem";
  const iconSize = size === "medium" ? "1.5rem" : "1rem";
  
  return (
    <TopicCardSignatureStack
      flexGrow={ 1 }
      { ...props }
    >

      {
        created ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ "4px" }>
            <Timer
              size={ iconSize }
              color={ color || theme.customColors.exploreCardText }
            />
            <InfoTypography 
              color={ color || theme.customColors.exploreCardText }
              fontSize={ fontSize }
            >
              { created }
            </InfoTypography>

            {
              isModified ?
                <InfoTypography 
                  color={ color || theme.customColors.exploreCardText }
                  fontSize={ fontSize }
                > 
                  {  "( " +  t("modified") + " )" }
                </InfoTypography> 
                : null
            }
          </Stack> : null
      }

      {
        readingTime ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ 1 }
          >
            <Glasses
              color={ color || theme.customColors.exploreCardText }
              size={ iconSize }
            />
            <InfoTypography 
              color={ color || theme.customColors.exploreCardText }
              fontSize={ fontSize }
            > 
              { readingTime } 
            </InfoTypography>
          </Stack> :
          null
      }
    </TopicCardSignatureStack>
  );

}
